import scrrroll from 'scrrroll';
import collapsible from '@/app/collapsible';

export default function(dom, opts) {
	let options = {
		...opts
	};

	const urlId = window.location.hash.replace('#', '');

	const categories = Array.from(dom.querySelectorAll('.faq__category'));
	const questions = Array.from(dom.querySelectorAll('.faq__item'));
	let openCategories = new Set();

	categories.forEach((category, i) => {
		const callback = collapsed => {
			if (collapsed) {
				openCategories.delete(i);
			}
			else {
				openCategories.add(i);
			}
			if (openCategories.size) {
				dom.classList.add('faq--open-cat');
			}
			else {
				dom.classList.remove('faq--open-cat');
			}
		};

		collapsible(category, {
			triggerSelector: '.faq__category-title',
			contentSelector: '.faq__category-content',
			collapsedClass: 'faq__category--collapsed',
			callback,
		});

		if (category.dataset.category == urlId) {
			category.classList.remove('faq__category--collapsed');
			callback(false);
			scrrroll.to(category);
		}
	});

	questions.forEach(question => {
		collapsible(question, {
			triggerSelector: '.faq__item-question',
			contentSelector: '.faq__item-content',
			collapsedClass: 'faq__item--collapsed',
		});
	});
}
